import { render } from "./MMFooter.vue?vue&type=template&id=d2fdaaf6"
import script from "./MMFooter.vue?vue&type=script&lang=js"
export * from "./MMFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__